import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import worksReducer from '../pages/works/works.reducer';

export const store = configureStore({
  reducer: {
    works: worksReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
